<template>
  <div class="columns my-0">
    <div class="column is-4">
      <kst-input floating-label load-on-focus
        field="Search" :data="searchData" :catalog="SearchCatalog"
        @input="handleInput"
      />
    </div>

    <div class="column is-narrow">
      <kst-input floating-label
        field="CategoryID" :data="searchData" :catalog="SearchCatalog"
        :options="categoryOptions" @input="handleInput"
      />
    </div>

    <div class="column is-narrow">
      <kst-input floating-label
        field="IsActive" :data="searchData" :catalog="SearchCatalog"
        :options="statusOptions" @input="handleInput"
      />
    </div>

    <div class="column is-narrow">
      <kst-button reset-mode @click="handleReset"/>
    </div>
  </div>
</template>

<script>
import SearchCatalog from "./ExpenseSubCategorySettingSearchCatalog.js";
import SearchMixin from "@/mixins/SearchMixin.js";

export default {
  mixins: [SearchMixin],
  props: {
    searchData: Object,
    categoryOptions: Object,
    statusOptions: Object,
  },
  data: () => ({
    SearchCatalog: SearchCatalog
  }),
  created() {
    this.initSearch(this.searchData, this.submit);
  },
  methods: {
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    handleReset() {
      this.$emit(this.$kst.Enum.Event.Reset);
    }
  }
}
</script>